﻿import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomDropdown from "@/components/desktop/list/dropdown/CustomDropdown";
import { AlertCircle, History as HistoryIcon } from "lucide-react";

const InventoryTableItem = ({ indice, handleShowMovements }) => {
	const navigate = useNavigate();
	const { inventories } = useSelector((state) => state.inventory);

	const inventory = inventories[indice];

	const handleStockAction = (inv) => {
		navigate(`/inventario/stock_critico/${inv.CODIGO_PRODUCTO}`);
	};

	const onShowMovements = (inv) => {
		const detail = { ...inv, INVENTORY_ID: String(inv.ID_INVENTARIO ?? inv.INVENTORY_ID) };
		handleShowMovements(detail);
	};

	const items = [
		{
			label: "Ingresar Stock Crítico",
			action: () => handleStockAction(inventory),
			icon: AlertCircle,
		},
		{
			label: "Ver Movimientos",
			action: () => onShowMovements(inventory),
			icon: HistoryIcon,
		},
	];

	return <CustomDropdown title="Acciones" items={items} align="right" />;
};

export default InventoryTableItem;
